var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Users"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 19.1968C15.853 19.4445 16.7368 19.5698 17.625 19.5688C19.0534 19.5709 20.4633 19.2452 21.746 18.6168C21.7839 17.7205 21.5286 16.8363 21.0188 16.0982C20.509 15.36 19.7724 14.8082 18.9207 14.5264C18.0691 14.2445 17.1487 14.248 16.2992 14.5362C15.4497 14.8245 14.7173 15.3819 14.213 16.1238M15 19.1968V19.1938C15 18.0808 14.714 17.0338 14.213 16.1238M15 19.1968V19.3028C13.0755 20.4619 10.8706 21.0726 8.62402 21.0688C6.29302 21.0688 4.11202 20.4238 2.25002 19.3028L2.24902 19.1938C2.24826 17.7783 2.71864 16.4028 3.58601 15.2841C4.45338 14.1654 5.6684 13.3673 7.03951 13.0154C8.41063 12.6636 9.85985 12.7781 11.1587 13.3409C12.4575 13.9037 13.5321 14.8828 14.213 16.1238M12 6.44385C12 7.33895 11.6444 8.1974 11.0115 8.83033C10.3786 9.46327 9.52013 9.81885 8.62502 9.81885C7.72992 9.81885 6.87147 9.46327 6.23854 8.83033C5.6056 8.1974 5.25002 7.33895 5.25002 6.44385C5.25002 5.54874 5.6056 4.6903 6.23854 4.05736C6.87147 3.42443 7.72992 3.06885 8.62502 3.06885C9.52013 3.06885 10.3786 3.42443 11.0115 4.05736C11.6444 4.6903 12 5.54874 12 6.44385ZM20.25 8.69385C20.25 9.39004 19.9735 10.0577 19.4812 10.55C18.9889 11.0423 18.3212 11.3188 17.625 11.3188C16.9288 11.3188 16.2612 11.0423 15.7689 10.55C15.2766 10.0577 15 9.39004 15 8.69385C15 7.99765 15.2766 7.32998 15.7689 6.83769C16.2612 6.34541 16.9288 6.06885 17.625 6.06885C18.3212 6.06885 18.9889 6.34541 19.4812 6.83769C19.9735 7.32998 20.25 7.99765 20.25 8.69385Z",
    stroke: "#E8E9E9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.0fd0a93f42a7da88b920e019ed545fa2.svg";
export { ForwardRef as ReactComponent };